'use client';

import React, { useEffect, useState } from 'react';

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Text } from '@mantine/core';

import dayjs from '@utils/dayjs';

const DEFAULT_STYLES = {
    backgroundColor: 'var(--mantine-color-nli-error-filled)',
    textColor: '#fff',
    bold: false,
};

export default function TopAnnouncementBanner({ data, demo }) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    // Vérifier si data est un objet vide (pas de données réelles)
    const hasData = data && Object.keys(data).length > 0 && data.text;

    // Déterminer si la bannière doit être affichée (seulement après montage côté client)
    const shouldDisplay = mounted && (demo || (
        hasData &&
        data.active &&
        (!data.startDate || dayjs().isAfter(dayjs(data.startDate))) &&
        (!data.endDate || dayjs().isBefore(dayjs(data.endDate)))
    ));

    // Utiliser les styles par défaut en mode demo, sinon utiliser les styles de data
    const styles = demo ? DEFAULT_STYLES : {
        backgroundColor: data?.backgroundColor || DEFAULT_STYLES.backgroundColor,
        textColor: data?.textColor || DEFAULT_STYLES.textColor,
        bold: data?.bold || DEFAULT_STYLES.bold,
    };

    const text = demo ? 'DEMO MODE' : data?.text;
    const isSticky = demo ? true : data?.sticky;

    // Toujours rendre le conteneur pour éviter le layout shift
    // mais le rendre invisible et sans hauteur si pas de contenu à afficher
    return (
        <Flex
            pos={isSticky ? 'sticky' : 'fixed'}
            top="0px"
            left="0px"
            right="0px"
            h={shouldDisplay ? 25 : 0}
            justify="center"
            align="center"
            gap="xs"
            bg={shouldDisplay ? styles.backgroundColor : 'transparent'}
            style={{
                zIndex: 100000,
                overflow: 'hidden',
                transition: 'height 0.15s ease-in-out',
            }}
        >
            {shouldDisplay && demo ? (
                <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    color="#fff"
                    flip
                    style={{ '--fa-animation-duration': '4s' }}
                />
            ) : null}
            {shouldDisplay ? (
                <Text c={styles.textColor} fw={styles.bold ? 'bold' : 'normal'}>
                    {text}
                </Text>
            ) : null}
        </Flex>
    );
}